"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var antd_1 = require("antd");
var _get = require('lodash/get');
var _set = require('lodash/set');
var _isEqual = require('lodash/isEqual');
var _cloneDeep = require('lodash/cloneDeep');
var TreeNode = antd_1.Tree.TreeNode;
require("./FilterTree.css");
var ComparisonFilter_1 = __importDefault(require("../ComparisonFilter/ComparisonFilter"));
var LocaleWrapper_1 = require("../../LocaleWrapper/LocaleWrapper");
var en_US_1 = __importDefault(require("../../../locale/en_US"));
/**
 * UI for a ComparisonFilter consisting of
 *
 *   - A combo to select the attribute
 *   - A combo to select the operator
 *   - An input field for the value
 */
var FilterTree = /** @class */ (function (_super) {
    __extends(FilterTree, _super);
    function FilterTree(props) {
        var _this = _super.call(this, props) || this;
        _this.shouldComponentUpdate = function (nextProps, nextState) {
            var diffProps = !_isEqual(_this.props, nextProps);
            var diffState = !_isEqual(_this.state, nextState);
            return diffProps || diffState;
        };
        /**
         * Changehandler for ComparsionFilters.
         *
         */
        _this.onComparisonFilterChange = function (filter, position) {
            var rootFilter = _this.props.filter;
            if (_isEqual(filter, rootFilter)) {
                _this.props.onFilterChange(filter);
            }
            var newFilter = _cloneDeep(rootFilter);
            if (position === '') {
                newFilter = filter;
            }
            else {
                _set(newFilter, position, filter);
            }
            _this.props.onFilterChange(newFilter);
        };
        /**
         * Creates a TreeNode for a given filter at the given position.
         *
         * @return Tree.TreeNode
         */
        _this.getNodeByFilter = function (filter, position) {
            if (position === void 0) { position = ''; }
            var _a = _this.props, internalDataDef = _a.internalDataDef, locale = _a.locale, filterUiProps = _a.filterUiProps;
            var operator = filter[0];
            var showRemoveButton = false;
            var parentPosition = position.substring(0, position.length - 3);
            var parentFilter = position === '' ? null : _this.getFilterAtPosition(parentPosition);
            if (parentFilter) {
                var parentOperator = parentFilter[0];
                if (parentOperator === '&&' || parentOperator === '||') {
                    showRemoveButton = true;
                }
            }
            var addFilterMenu = (React.createElement(antd_1.Menu, { onClick: function (_a) {
                    var key = _a.key;
                    return _this.addFilter(position, key);
                } },
                React.createElement(antd_1.Menu.Item, { key: "and" }, locale.andDrpdwnLabel),
                React.createElement(antd_1.Menu.Item, { key: "or" }, locale.orDrpdwnLabel),
                React.createElement(antd_1.Menu.Item, { key: "not" }, locale.notDrpdwnLabel),
                React.createElement(antd_1.Menu.Item, { key: "comparison" }, locale.comparisonDrpdwnLabel)));
            var changeFilterMenu = (React.createElement(antd_1.Menu, { onClick: function (_a) {
                    var key = _a.key;
                    return _this.changeFilter(position, key);
                } },
                React.createElement(antd_1.Menu.Item, { key: "and" }, locale.andDrpdwnLabel),
                React.createElement(antd_1.Menu.Item, { key: "or" }, locale.orDrpdwnLabel),
                React.createElement(antd_1.Menu.Item, { key: "not" }, locale.notDrpdwnLabel),
                React.createElement(antd_1.Menu.Item, { key: "comparison" }, locale.comparisonDrpdwnLabel)));
            var addButton = (React.createElement(antd_1.Tooltip, { title: locale.addFilterLabel, placement: "top" },
                React.createElement(antd_1.Dropdown, { trigger: ['click'], overlay: addFilterMenu },
                    React.createElement(antd_1.Button, { size: "small" },
                        React.createElement(antd_1.Icon, { type: "plus" })))));
            var removeButton = (React.createElement(antd_1.Tooltip, { title: locale.removeFilterLabel, placement: "right" },
                React.createElement(antd_1.Button, { size: "small", onClick: function () { return _this.removeFilter(position); } },
                    React.createElement(antd_1.Icon, { type: "minus" }))));
            var changeButton = (React.createElement(antd_1.Tooltip, { title: locale.changeFilterLabel, placement: "left" },
                React.createElement(antd_1.Dropdown, { trigger: ['click'], overlay: changeFilterMenu },
                    React.createElement(antd_1.Button, { size: "small" },
                        React.createElement(antd_1.Icon, { type: "filter" })))));
            var combinedFilters = filter.slice(1);
            switch (operator) {
                case '&&':
                    return (React.createElement(TreeNode, { className: "style-filter-node and-filter", key: position, isLeaf: false, title: React.createElement("span", { className: "node-title" },
                            React.createElement("span", { className: "filter-text" }, locale.andFilterText),
                            React.createElement("span", { className: "filter-tools" },
                                changeButton,
                                addButton,
                                showRemoveButton ? removeButton : undefined)) }, combinedFilters.map(function (subFilter, index) {
                        var pos = position + "[" + (index + 1) + "]";
                        return _this.getNodeByFilter(subFilter, pos);
                    })));
                case '||':
                    return (React.createElement(TreeNode, { className: "style-filter-node or-filter", key: position, isLeaf: false, title: React.createElement("span", { className: "node-title" },
                            React.createElement("span", { className: "filter-text" }, locale.orFilterText),
                            React.createElement("span", { className: "filter-tools" },
                                changeButton,
                                addButton,
                                showRemoveButton ? removeButton : undefined)) }, combinedFilters.map(function (subFilter, index) {
                        var pos = position + "[" + (index + 1) + "]";
                        return _this.getNodeByFilter(subFilter, pos);
                    })));
                case '!':
                    return (React.createElement(TreeNode, { className: "style-filter-node not-filter", key: position, isLeaf: false, title: React.createElement("span", { className: "node-title" },
                            React.createElement("span", { className: "filter-text" }, locale.notFilterText),
                            React.createElement("span", { className: "filter-tools" },
                                changeButton,
                                showRemoveButton ? removeButton : undefined)) }, _this.getNodeByFilter(filter[1], position + "[1]")));
                default:
                    return (React.createElement(TreeNode, { className: "style-filter-node comparison-filter", key: position, isLeaf: true, title: React.createElement("span", { className: "node-title" },
                            React.createElement("span", null,
                                React.createElement(ComparisonFilter_1.default, __assign({ microUI: true, internalDataDef: internalDataDef, filter: filter, onFilterChange: function (f) { return _this.onComparisonFilterChange(f, position); } }, filterUiProps))),
                            React.createElement("span", { className: "filter-tools" },
                                changeButton,
                                showRemoveButton ? removeButton : undefined)) }));
            }
        };
        /**
         * Handler for the add button.
         * Adds a filter of a given type at the given position.
         *
         */
        _this.addFilter = function (position, type) {
            var _a = _this.props, filter = _a.filter, onFilterChange = _a.onFilterChange;
            var addedFilter;
            // const newFilter: GsFilter = [...filter];
            var newFilter = _cloneDeep(filter);
            switch (type) {
                case 'and':
                    addedFilter = ['&&', ['==', '', ''], ['==', '', '']];
                    break;
                case 'or':
                    addedFilter = ['||', ['==', '', ''], ['==', '', '']];
                    break;
                case 'not':
                    addedFilter = ['!', ['==', '', '']];
                    break;
                case 'comparison':
                default:
                    addedFilter = ['==', '', ''];
                    break;
            }
            if (position === '') {
                newFilter.push(addedFilter);
            }
            else {
                var previousFilter = _get(newFilter, position);
                previousFilter.push(addedFilter);
                _set(newFilter, position, previousFilter);
            }
            onFilterChange(newFilter);
        };
        /**
         * Changes a filter at a position to a given typ.
         *
         */
        _this.changeFilter = function (position, type) {
            var _a = _this.props, filter = _a.filter, onFilterChange = _a.onFilterChange;
            var addedFilter;
            var newFilter = _cloneDeep(filter);
            var previousFilter = position === '' ? newFilter : _get(newFilter, position);
            switch (type) {
                case 'and':
                    if (previousFilter && (previousFilter[0] === '&&' || previousFilter[0] === '||')) {
                        addedFilter = previousFilter;
                        addedFilter[0] = '&&';
                    }
                    else {
                        addedFilter = ['&&', ['==', '', ''], ['==', '', '']];
                    }
                    break;
                case 'or':
                    if (previousFilter && (previousFilter[0] === '&&' || previousFilter[0] === '||')) {
                        addedFilter = previousFilter;
                        addedFilter[0] = '||';
                    }
                    else {
                        addedFilter = ['||', ['==', '', ''], ['==', '', '']];
                    }
                    break;
                case 'not':
                    addedFilter = ['!', ['==', '', '']];
                    break;
                case 'comparison':
                default:
                    addedFilter = ['==', '', ''];
                    break;
            }
            if (position === '') {
                onFilterChange(addedFilter);
                return;
            }
            else {
                _set(newFilter, position, addedFilter);
            }
            onFilterChange(newFilter);
        };
        /**
         * Removes a filter at a given position.
         *
         */
        _this.removeFilter = function (position) {
            var _a = _this.props, filter = _a.filter, onFilterChange = _a.onFilterChange;
            var parentPosition = position.substring(0, position.length - 3);
            var parentFilter = _this.getFilterAtPosition(parentPosition);
            var newFilter;
            if (parentFilter.length <= 2) {
                newFilter = _this.removeAtPosition(filter, parentPosition);
            }
            else {
                newFilter = _this.removeAtPosition(filter, position);
            }
            onFilterChange(newFilter);
        };
        /**
         * Transforms a position String like '[2][3]' to an positionArray like [2, 3].
         */
        _this.positionStringAsArray = function (positionString) {
            return positionString
                .replace(/\]\[/g, ',')
                .replace(/\]/g, '')
                .replace(/\[/g, '')
                .split(',')
                .map(function (i) { return parseInt(i, 10); });
        };
        /**
         * Transforms am positionArray like [2, 3] to a string like '[2][3]'.
         */
        _this.positionArrayAsString = function (positionArray) {
            return "[" + positionArray.toString().replace(/,/g, '][') + "]";
        };
        /**
         * Returns the filter at a specific position.
         */
        _this.getFilterAtPosition = function (position) {
            var filter = _this.props.filter;
            if (position === '') {
                return filter;
            }
            else {
                return _get(filter, position);
            }
        };
        /**
         * Removes a subfilter from a given filter at the given position.
         */
        _this.removeAtPosition = function (filter, position) {
            var newFilter = filter.slice();
            var dragNodeSubPosition = position.substr(position.length - 3);
            var dragNodeIndex = parseInt(dragNodeSubPosition.slice(1, 2), 10);
            var parentPosition = position.substring(0, position.length - 3);
            var parentFilter = newFilter;
            if (parentPosition !== '') {
                parentFilter = _get(newFilter, parentPosition);
            }
            parentFilter.splice(dragNodeIndex, 1);
            return newFilter;
        };
        /**
         * Inserts a given subfilter to a given parentfilter by its position and its
         * dropPosition.
         */
        _this.insertAtPosition = function (rootFilter, insertFilter, position, dropPosition) {
            var dropTargetParentPosition = position.substring(0, position.length - 3);
            var dropTargetSubPosition = position.substr(position.length - 3);
            var dropTargetSubIndex = dropTargetParentPosition === ''
                ? 1
                : parseInt(dropTargetSubPosition.slice(1, 2), 10);
            var dropTargetIsComparison = !['&', '||', '!'].includes(insertFilter[0]);
            var newFilter = rootFilter.slice();
            var newSubFilter = dropTargetParentPosition === ''
                ? newFilter
                : _get(newFilter, dropTargetParentPosition);
            // Add to new position
            switch (dropPosition) {
                // before
                case 0:
                    newSubFilter.splice(dropTargetSubIndex, 0, insertFilter);
                    break;
                // on
                case 1:
                    dropTargetIsComparison
                        ? newSubFilter.splice(dropTargetSubIndex + 1, 0, insertFilter)
                        : newSubFilter.push(insertFilter);
                    break;
                // after
                case 2:
                    newSubFilter.splice(dropTargetSubIndex + 1, 0, insertFilter);
                    break;
                default:
                    break;
            }
            return newFilter;
        };
        /**
         * Drop handler which is passed to the Tree.
         * Removes filter from the dragged position and adds it to the dropped position.
         */
        _this.onDrop = function (dropObject) {
            var rootFilter = _this.props.filter;
            var dragNode = dropObject.dragNode, dropPosition = dropObject.dropPosition, node = dropObject.node;
            var newFilter = rootFilter.slice();
            var dragNodePosition = dragNode.props.eventKey;
            var draggedFilter = _get(rootFilter, dragNodePosition);
            var dragParentPosition = dragNodePosition.substring(0, dragNodePosition.length - 3);
            var dragParentFilter = dragParentPosition === '' ? rootFilter : _get(rootFilter, dragParentPosition);
            var dragPositionArray = _this.positionStringAsArray(dragNodePosition);
            var dragSubPosition = dragPositionArray[dragPositionArray.length - 1];
            var dropTargetPosition = node.props.eventKey === '0-0' ? '' : node.props.eventKey;
            var dropParentPosition = dropTargetPosition.substring(0, dropTargetPosition.length - 3);
            var dropPositionArray = _this.positionStringAsArray(dropTargetPosition);
            var dropSubPosition = dropPositionArray[dropPositionArray.length - 1];
            var sameParent = dragParentPosition === dropParentPosition;
            var draggedLastRemaingChild = dragParentFilter.length <= 2;
            var removePositionArray = dragPositionArray.slice();
            // Get remove position. Calculate the modified indexes after the node is added.
            // We dropped to the root node
            if (dropTargetPosition === '' || dropParentPosition === '') {
                var droppedBefore = dropTargetPosition === '' || dropPositionArray[0] < dragPositionArray[0];
                if (droppedBefore) {
                    removePositionArray[0] = dragPositionArray[0] + 1;
                }
            }
            // We dropped inside the same CompositionFilter
            if (sameParent) {
                if (dropSubPosition < dragSubPosition) {
                    var subIndex = removePositionArray.length - 1;
                    removePositionArray[subIndex] = dragSubPosition + 1;
                }
            }
            else {
                if (draggedLastRemaingChild) {
                    removePositionArray = _this.positionStringAsArray(dragParentPosition);
                }
            }
            var removePosition = _this.positionArrayAsString(removePositionArray);
            // Insert into new position
            newFilter = _this.insertAtPosition(newFilter, draggedFilter, dropTargetPosition, dropPosition);
            // Remove from old position
            newFilter = _this.removeAtPosition(newFilter, removePosition);
            _this.props.onFilterChange(newFilter);
        };
        /**
         * Expand handler which is passed to the Tree.
         * Sets the expandedKeys to the state and so back to the tree.
         */
        _this.onExpand = function (expandedKeys) {
            _this.setState({ expandedKeys: expandedKeys });
        };
        _this.state = {
            expandedKeys: [],
            hasError: false
        };
        return _this;
    }
    FilterTree.prototype.componentDidCatch = function (error, errorInfo) {
        this.setState({
            hasError: true
        });
    };
    FilterTree.prototype.render = function () {
        if (this.state.hasError) {
            return React.createElement("h1", null, "An error occured in the FilterTree UI.");
        }
        var filter = this.props.filter;
        var expandedKeys = this.state.expandedKeys;
        return (React.createElement(antd_1.Tree, { className: "gs-filter-tree", draggable: true, expandedKeys: expandedKeys, onExpand: this.onExpand, onDrop: this.onDrop }, this.getNodeByFilter(filter)));
    };
    FilterTree.defaultProps = {
        filter: ['==', '', null],
        locale: en_US_1.default.GsFilterTree
    };
    FilterTree.componentName = 'FilterTree';
    return FilterTree;
}(React.Component));
exports.FilterTree = FilterTree;
exports.default = LocaleWrapper_1.localize(FilterTree, FilterTree.componentName);
//# sourceMappingURL=FilterTree.js.map